import PropTypes from 'prop-types'
import LinkButton from './LinkButton'

const LinkButtonBox = (props) => {
  const { to, onClick, disabled, className, classNameIcono, texto, ...rest } = props

  return (
    <LinkButton
      to={to}
      onClick={onClick}
      className={className}
      disabled={disabled}
      {...rest}
    >
      <div>{classNameIcono && <i className={classNameIcono} aria-hidden="true" />}</div>
      <br />
      <div>{texto && texto}</div>
    </LinkButton>
  )
}

LinkButtonBox.propTypes = {
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      state: PropTypes.object
    })
  ]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  classNameIcono: PropTypes.string,
  texto: PropTypes.string
}

export default LinkButtonBox
